import React, { useEffect, useRef, useState } from 'react'

import styled from 'styled-components';

export default function ScrollUp() {
  const [scrollUpVisible, setScrollUpVisible] = useState(false);
  const scrollUpRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 140) {
        setScrollUpVisible(true);
      } else {
        setScrollUpVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };

  }, []);

  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <SCROLL_UP $scrollUpVisible={scrollUpVisible} onClick={handleClick}>
      <svg
        ref={scrollUpRef}
        viewBox="0 0 60 60"
        fill="transparent"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="30" cy="30.0002" r="29.5" transform="rotate(-180 30 30.0002)" stroke="#8C8C8C"/>
        <path d="M38 28.1693L30 21M30 21L22 28.1693M30 21L30 40.1181" stroke="#8C8C8C"/>
      </svg>
    </SCROLL_UP>
  )
}

const SCROLL_UP = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 100;

  width: 3.75rem;
  height: 3.75rem;

  opacity: ${({ $scrollUpVisible }) => ($scrollUpVisible ? '1' : '0')};
  transition: opacity 0.2s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: ${({ $scrollUpVisible }) => ($scrollUpVisible ? 'pointer' : 'default')};

      & svg circle {
        fill: var(--swiper-color);
      }

      & svg path {
        stroke: white;
      }
    }
  }

  @media (min-width: 768px) {
    right: 7rem;
    bottom: 7.5rem;
  }
`;
